export default "__VITE_ASSET__DDpIKDnV__"